import { render, staticRenderFns } from "./ServicesReservationTreatmentPlanForm.vue?vue&type=template&id=16927028&scoped=true&"
import script from "./ServicesReservationTreatmentPlanForm.vue?vue&type=script&lang=js&"
export * from "./ServicesReservationTreatmentPlanForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16927028",
  null
  
)

export default component.exports